import axios from "axios";
import config from "../config/config";
import { getHeaders } from "./apiHelper";

const API_URL = config.API_URL; 

export const getRedeems = async () => {
  const response = await axios.get(`${API_URL}redeem`, { headers: getHeaders() });
  return response.data;
};

const buildRedeemFormData = (data, isUpdate = false) => {
  if (typeof FormData !== "undefined" && data instanceof FormData) {
    if (isUpdate && !data.has("_method")) {
      data.append("_method", "PUT");
    }
    return data;
  }
  const formData = new FormData();
  const fields = {
    name: data?.name,
    gold: data?.gold,
    description: data?.description,
    stock: data?.stock,
    category_id: data?.category_id ?? data?.categoryId,
  };
  Object.keys(fields).forEach((key) => {
    if (fields[key] !== undefined && fields[key] !== null && fields[key] !== "") {
      formData.append(key, fields[key]);
    }
  });
  if (data?.image) {
    formData.append("image", data.image);
  }
  if (isUpdate) {
    formData.append("_method", "PUT");
  }
  return formData;
};

export const storeRedeem = async (redeem) => {
  const payload = buildRedeemFormData(redeem, false);
  const response = await axios.post(`${API_URL}redeem`, payload, { headers: getHeaders(true) });
  return response.data;
};

export const getDetailRedeem = async (id) => {
  const response = await axios.get(`${API_URL}redeem/${id}`, { headers: getHeaders() });
  return response.data;
};

export const deleteRedeem = async (id) => {
  const response = await axios.delete(`${API_URL}redeem/${id}`, { headers: getHeaders() });
  return response.data;
};

export const updateRedeem = async (id, data) => {
  const payload = buildRedeemFormData(data, true);
  const response = await axios.post(`${API_URL}redeem/${id}`, payload, { headers: getHeaders(true) });
  return response.data;
};
